export default __webpack_public_path__ + "static/media/B79.5479a425.png";